import { pb } from '@/utils/pocketbase';
import requests from "@/utils/requests";
import { safePb } from "@/utils/pocketbase-safe";

/**
 * Storage 模块：对接 PocketBase "files" 集合
 */

// 1. 获取文件列表 (分页)
export const listFiles = async ({ category, page_size, page_number }) => {
    try {
        const filter = `kind = "${category.toLowerCase()}"`;
        const resultList = await pb.collection('files').getList(page_number, page_size, {
            filter,
            sort: '-created',
            requestKey: null,
        });

        return {
            code: 0,
            data: {
                file_list: resultList.items.map(item => ({
                    file_id: item.id,
                    display_name: item.tags?.displayName || item.name,
                    identifier: item.id,
                    description: item.tags?.description || '',
                    create_time: new Date(item.created).toLocaleString(),
                    status: (item.status || 'uploading').toUpperCase(),
                    suffix: (item.name || '').split('.').pop(),
                    storage_key: item.key,
                    ancestry: item.ancestry || item.tags?.ancestry || item.tags?.pop || '',
                    
                })),
                total_count: resultList.totalItems,
            },
        };
    } catch (error) {
        return { code: error.status || 500, message: error.message };
    }
};

// 2. 物理文件上传 (自动处理物理路径)
export const uploadFileRecord = async (formData, onProgress, signal) => {
    try {
        const record = await pb.collection("files").create(formData, {
            signal,
            requestKey: null,
            onSendProgress: onProgress,
        });

        const res = await requests.post(
            "/api/storage/file/finalize",
            {
                recordId: record.id,
                collectionId: record.collectionId,
                filename: record.file,
            },
            null,
            { signal }
        );

        if (res.code !== 0) {
            throw new Error(res.message || "Finalize failed");
        }

        return {
            ...record,
            bucket: res?.data?.bucket || "pocketbase",
            key: res?.data?.key || "",
            status: res?.data?.status || "available",
        };
    } catch (error) {
        if (error?.status === 400 && error?.data?.data) {
            const details = Object.entries(error.data.data)
                .map(([field, info]) => `${field}: ${info.message}`)
                .join("; ");
            throw new Error(`PB Validation Error: ${details}`);
        }
        throw error;
    }
};

// 3. 注册/完善信息 (供业务调用)
export const registerFile = async (payload) => {
    try {
        // 注意：你的 schema 里 status 允许值必须包含 available，否则会 400
        const record = await pb.collection('files').update(payload.storage_path, {
            status: 'available',
            "tags+": {
                displayName: payload.display_name,
                description: payload.description,
                identifier: payload.identifier
            }
        });

        return { code: 0, data: record };
    } catch (error) {
        return { code: 500, message: error.message };
    }
};

// 4. 删除文件
export const deleteFileResource = async (id) => {
    try {
        await safePb.collection('files').delete(id);
        return { code: 0 };
    } catch (error) {
        return { code: 500, message: error.message };
    }
};
// 5. 延长保留期（示例：延长 30 天）
export const refreshFileTTL = async (id, days = 30) => {
    try {
        const now = new Date();
        const next = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);

        // PocketBase 时间字段通常用 ISO 字符串
        const record = await safePb.collection("files").update(id, {
            expire_time: next.toISOString(),
            status: "available", // 可选：如果你 schema 允许
        });

        return { code: 0, data: record };
    } catch (error) {
        return { code: 500, message: error.message };
    }
};